import { isEmpty } from 'lodash-es';

app.directive('destinationSectionSfExpress', [
  'sfexpressService',
  function (sfexpressService) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.sf-express.html'),
      scope: {
        errors: '=',
        option: '=',
        disabled: '=',
        location: '=',
      },
      link: function (scope) {
        scope.selectedLocation = {};
        scope.registered = false;
        scope.allLocations = [];
        scope.availableSfLocations = [];
        scope.isSfPlus = scope.option?.region_type === 'hk_sfplus';

        function getDistrictLocation() {
          sfexpressService
            .getLocationByTypePromise(scope.option?.config_data?.sfexpress_type)
            .then(({ data }) => {
              scope.allLocations = parseLocation(data);
              scope.districtLocations = mergeLocationToDistrict(
                scope.allLocations,
              );
              setSelectedLocation(
                scope.location?.location_code,
                scope.allLocations,
              );
            });
        }

        scope.sfExpressType =
          scope.option?.config_data?.sfexpress_type ||
          sfexpressService.SF_EXPRESS_TYPES.circlek;

        scope.onDistrictChange = () => {
          scope.selectedLocation.location_code = undefined;
          scope.availableSfLocations =
            scope.selectedLocation?.district?.locations || [];
          scope.location = {
            district_translations:
              scope.selectedLocation?.district?.district_translations,
          };
        };

        scope.onLocationChange = () => {
          scope.location = getLocation(
            scope.selectedLocation.location_code,
            scope.allLocations,
          );
        };

        getDistrictLocation();

        // utils
        function getLocation(selectedCode, locations) {
          const location = locations.find(
            (location) => location.location_code === selectedCode,
          );
          return {
            ...location,
            location_code: location.location_code,
          };
        }

        function setSelectedLocation(locationCode, locations) {
          const location = locations.find(
            (location) => location.location_code === locationCode,
          );

          if (!isEmpty(location)) {
            const district = scope.districtLocations.find(
              (district) =>
                district.district_translations.en ===
                location.district_translations?.en,
            );

            scope.availableSfLocations = district.locations;
            scope.selectedLocation.location_code = location.location_code;
            scope.selectedLocation.district = district;
          }
        }

        function parseLocation(locations) {
          return locations.map((location) => ({
            ...location,
            location_code: location.code,
          }));
        }

        function mergeLocationToDistrict(locations) {
          return locations.reduce((result, location) => {
            const districtIndex = result.findIndex(
              (district) =>
                !isEmpty(district.district_translations?.en) &&
                district.district_translations.en ===
                  location.district_translations.en,
            );

            districtIndex >= 0
              ? result[districtIndex].locations.push(location)
              : result.push({
                  district_translations: location.district_translations,
                  locations: [location],
                });

            return result;
          }, []);
        }
      },
    };
  },
]);
